import { useCallback, useContext, useEffect, useState } from 'react';
import useUser from '../../api/hooks/useUser';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import { CategoryItem, Supplier, User } from '../../interfaces';
import { getRandomBgColor } from '../../utils/others';
import UserCard from './UserCard';
import useCategory from '../../api/hooks/useCategory';
import useToggle from '../../hooks/useToggle';
import { toIcons } from '../../consts/Paths';
import { useForm } from 'react-hook-form';
import DeleteModal from '../modals/DeleteModal';
import Loader from '../Loader';
import CustomModal from '../modals/CustomModal';
import CustomInput from '../inputs/CustomInput';
import useOffer from '../../api/hooks/useOffers';
import useManufacturers from '../../api/hooks/useManufacturers';

interface ManufacturerParams {
    id: number;
    companyName: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    country?: string;
    postalCode?: string;
    stateOrProvince?: string;
    phone?: string;
    email?: string;
    responsible_companyName: string;
    responsible_addressLine1?: string;
    responsible_addressLine2?: string;
    responsible_city?: string;
    responsible_country?: string;
    responsible_postalCode?: string;
    responsible_stateOrProvince?: string;
    responsible_phone?: string;
    responsible_email?: string;
    matching_brand: string;
    certDoc?: string;
    createdAt?: string;
}

const Manufacturers = (props: any) => {
    const { isMobile } = useIsMobile();

    const { isToggled } = props.resetList;

    const { user, userTreated } = useContext(MainContext);

    const { RESPONSES, RESULTS, CTAs } = useManufacturers();

    const [manufacturers, setManufacturers] = useState<ManufacturerParams[]>([
        {
            id: 0,
            companyName: 'Acme Inc.',
            addressLine1: '123 Main St',
            addressLine2: '', // Non sarà incluso
            city: 'Milan',
            country: 'Italy',
            postalCode: '20100',
            stateOrProvince: undefined, // Non sarà incluso
            phone: '1234567890',
            email: 'info@acme.com',
            responsible_companyName: 'Acme Responsible',
            responsible_email: '', // Non sarà incluso
            matching_brand: 'Acme Brand',
            certDoc: undefined, // Non sarà incluso
        },
    ]);

    const [edit, setEdit] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [item, setItem] = useState<ManufacturerParams>({
        id: 0,
        companyName: 'Acme Inc.',
        addressLine1: '123 Main St',
        addressLine2: '', // Non sarà incluso
        city: 'Milan',
        country: 'Italy',
        postalCode: '20100',
        stateOrProvince: undefined, // Non sarà incluso
        phone: '1234567890',
        email: 'info@acme.com',
        responsible_companyName: 'Acme Responsible',
        responsible_email: '', // Non sarà incluso
        matching_brand: 'Acme Brand',
        certDoc: undefined, // Non sarà incluso
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const onSubmit = (data: any) => {
        /* console.log("calling: create new user form"); */
        setIsLoading(true);
        CTAs.updateManufacturer(data, item.id);
    };

    const openEdit = (data: any) => {
        setItem(data);
        setEdit(true);
    };

    useEffect(() => {
        reset(); // Reset the form when the modal is closed
    }, [edit, item]);

    useEffect(() => {
        CTAs.getManufacturer();
    }, []);

    const handelOnDeleteClick = useCallback(
        (id: number) => {
            CTAs.deleteManufacturer(id);
        },
        [CTAs.deleteManufacturer]
    );

    useEffect(() => {
        /* console.log(registerResponse, registerResult); */
        if (RESPONSES.updateManufacturerResponse?.ok) {
            setIsLoading(false);
            setEdit(false);
        } else if (RESPONSES.updateManufacturerResponse?.ok === false) {
            setIsLoading(false);
        }
    }, [RESPONSES.updateManufacturerResponse]);

    useEffect(() => {
        /* console.log(RESPONSES.getUsersListResponse, RESULTS.getUsersListResult); */
        if (RESPONSES.getManufacturerResponse?.ok) {
            setManufacturers(RESULTS.getManufacturerResult);
            setIsLoading(false);
        }
    }, [RESPONSES.getManufacturerResponse, RESPONSES.updateManufacturerResponse]);

    const renderSuppliers = manufacturers.map((manufacturer) => {
        return (
            <div key={manufacturer.id} style={{ margin: '10px 0px' }} className='user-card'>
                <p style={{ fontFamily: 'Roboto', marginRight: '20px' }}>{manufacturer.companyName}</p>
                <p style={{ fontFamily: 'Roboto', marginRight: '20px' }}>{manufacturer.responsible_companyName}</p>
                <p style={{ fontFamily: 'Roboto', marginRight: '20px' }}>{manufacturer.matching_brand}</p>

                <button style={{ width: 50, marginLeft: 10, height: 20, paddingTop: 5, borderRadius: 14 }} className='add-button' onClick={() => openEdit(manufacturer)}>
                    <p style={{ fontSize: 12, margin: 0 }} className='add-buttonText'>
                        Edit
                    </p>
                </button>
                <img
                    style={{
                        cursor: 'pointer',
                        marginLeft: 'auto',
                        marginRight: isMobile ? '' : '20px',
                    }}
                    src={`${toIcons}/close.svg`}
                    onClick={() => handelOnDeleteClick(manufacturer.id)}
                />
            </div>
        );
    });

    return (
        <div
            className='users-table shadow'
            style={{
                width: isMobile ? '345px' : '',
                margin: isMobile ? '35px 16px' : '',
            }}
        >
            {edit && (
                <CustomModal setShow={setEdit} title='Modifica' description=''>
                    <form onSubmit={handleSubmit(onSubmit)} style={{ height: '743px', overflow: 'scroll' }}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '25px',
                                marginTop: '22px',
                            }}
                        >
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Company Name'
                                name='companyName'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: true }} // unique
                                defaultValue={item?.companyName}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Address Line 1'
                                name='addressLine1'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.addressLine1}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Address Line 2'
                                name='addressLine2'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.addressLine2}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='City'
                                name='city'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.city}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Country'
                                name='country'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.country}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Postal Code'
                                name='postalCode'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.postalCode}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='State or Province'
                                name='stateOrProvince'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.stateOrProvince}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Phone'
                                name='phone'
                                type='number'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.phone}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Email'
                                name='email'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.email}
                            />
                            <hr />
                            {/* Responsible Person Fields */}
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Company Name'
                                name='responsible_companyName'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: true }} // obbligatorio
                                defaultValue={item?.responsible_companyName}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Address Line 1'
                                name='responsible_addressLine1'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.responsible_addressLine1}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Address Line 2'
                                name='responsible_addressLine2'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.responsible_addressLine2}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible City'
                                name='responsible_city'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.responsible_city}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Country'
                                name='responsible_country'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.responsible_country}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Postal Code'
                                name='responsible_postalCode'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.postalCode}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible State or Province'
                                name='responsible_stateOrProvince'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.responsible_stateOrProvince}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Phone'
                                name='responsible_phone'
                                type='number'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.responsible_phone}
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Email'
                                name='responsible_email'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.responsible_email}
                            />
                            <hr />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Matching Brand'
                                name='matching_brand'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: true }} // unique
                                defaultValue={item?.matching_brand}
                            />

                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Certification Document'
                                name='certDoc'
                                type='text'
                                register={register}
                                errors={errors}
                                constraints={{ required: false }} // nullable
                                defaultValue={item?.certDoc}
                            />
                        </div>
                        <input type='text' value={item.id} hidden {...register('id')} />
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <button style={{ width: 70, marginTop: 20 }} className='add-button' type='submit'>
                                <p className='add-buttonText'>Salva</p>
                            </button>
                        )}
                    </form>
                </CustomModal>
            )}
            <div
                className='user-table-header'
                style={{
                    justifyContent: isMobile ? 'space-between' : '',
                    margin: '31px 25px',
                }}
            >
                <div className='user-table-header-title-box'>
                    <p className='user-table-header-title'>Produttori</p>
                    <p className='user-table-header-description'>Manage Produttori</p>
                </div>
                <button className='user-table-header-button shadow' type='button' onClick={props.toggler.toggle}>
                    <p className='user-table-header-button-text'>Add produttore</p>
                </button>
            </div>
            <div className='user-table-content'>
                <div className='offers-table'>
                    <div className='offers-table-fields'>
                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                                marginRight: '40px',
                            }}
                        >
                            <p className='field-label'>Company Name</p>
                        </div>

                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                                marginRight: '40px',
                            }}
                        >
                            <p className='field-label'>Responsible Company Name</p>
                        </div>

                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                                marginRight: '40px',
                            }}
                        >
                            <p className='field-label'>Matching Brand</p>
                        </div>

                        {!isMobile && (
                            <div className='u-mail'>
                                <p className='field-label'></p>
                            </div>
                        )}
                    </div>
                    <div className='divider' style={{ width: '100%', marginTop: '10px' }} />
                    {manufacturers.length > 0 ? <div className='users-table-results scroll-y'>{renderSuppliers}</div> : <Loader />}
                </div>
            </div>
        </div>
    );
};
export default Manufacturers;
